<template>
    <div>
        <bar-manut
        single-entity="Caixa PDV"
        plural-entity="Caixas PDV"
        :crud="this.crud"
        :btn-delete="true"
        @closeform="closeForm"
        @delete="handleDelete"
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            <!-- <div class="row">
                <form-field v-model="vcaixa.codvcaixa" :metadata="metadata.vcaixa.codvcaixa"  type="text" col="2" :disabled="true"></form-field>
            </div> -->
            <!-- <div class="row">
                <form-field v-model.number="vcaixa.codfil" :required="true" :metadata="metadata.vcaixa.codfil" type="select2"  name="codfil"  col="3" :disabled="isView"></form-field>
            </div> -->
            <div class="row">
                  <form-field v-model.trim="vcaixa.descricao" :v-errors="errors" v-validate="{required:true, max:40}" :required="true" :metadata="metadata.vcaixa.descricao" ref="descricao"  type="text" col="6"
                    name="descricao" :disabled="isView"></form-field>
            </div>
            <!-- <div class="row">
                <form-field type="color" v-model.trim="vcaixa.corfundo" :metadata="metadata.vcaixa.corfundo" col="2" :disabled="isView"></form-field>
            </div> -->
            <div class="row">
                <form-field v-model="vcaixa.stcaixa" placeholder="Selecione" :value="vcaixa.stcaixa" type="select"  :metadata="metadata.vcaixa.stcaixa" col="3" :disabled="isView"></form-field>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import InputTypeahead from '../components/input-typeahead'
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import {SysVars} from '../main'
export default {
    props:{
        index: '',
        crud:''
    },
        components: {
        InputTypeahead
    },
    data(){
        return{
            crudText: '',
            vcaixa: {...this.$store.getters.getEntities.vcaixa},
            metadata: this.$store.getters.getEntities.metadata,
            codvcaixa: 0,
            errMessages: [], // Armazena as mensagens de validações do servidor para mostrar na tela
            filial: {},
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        },
        isView(){
            return (this.crud == SysVars.crudView)
        },
        isCreditoLoja: function () {
            return this.vcaixa.formapag == '05' //credito loja
        },
        habilitaBandeira: function () {
            return (this.vcaixa.formapag == '03' || this.vcaixa.formapag ==  '04' || this.vcaixa.formapag ==  '10' || this.vcaixa.formapag ==  '11' || this.vcaixa.formapag ==  '12' || this.vcaixa.formapag == '13')
        },
     },

    methods:{
        closeForm(){
            this.$emit('closeform', this.vcaixa.codvcaixa)
        },
        handleSave(){
            // delete this.this.vcaixa.badeirapag && delete this.vcaixa.tpdiacredito
            //Validação do formulário
            this.$validator.validateAll().then(isValid =>{
                if(!isValid){
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else{
                    this.apiPost()
                }
            })
        },
        handleDelete(){
            this.apiDelete()
        },

        async loadFilial() {
          await apiORDS(this.$store.getters.urlOrds + 'cg/filial/varejo', null, true).then((result) => {
            if (result.items.length > 0) {
              this.filial = result.items[0];
            }
          })
        },

        async loadData(){
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadVCaixa', {id: this.index})
            if (this.$store.getters.getVCaixa){
                this.vcaixa = {...this.$store.getters.getVCaixa}
            }
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiPost(){
            //efetuaGravacao

            var modulo = 'cg/vcaixa/'
            var sendData = {}

            sendData = { vcaixa: this.vcaixa }

            let metodo = 'post'
            let update = false

            if(this.crud != SysVars.crudI){
                update = true
                metodo = 'put'
                modulo = modulo + this.vcaixa.codvcaixa
            }
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if(data.errmessages){
                this.errmessages = data.errmessages
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if(update){
                    this.$erpToastUpdated()
                } else{
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        async apiDelete(){
            //efetua exclusão
            var modulo = 'cg/vcaixa/' + this.vcaixa.codvcaixa
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        }
    },

    async created(){
        this.crudText = this.$crudText(this.crud)

        await this.loadFilial();

        if(this.crud == SysVars.crudI){
          this.vcaixa.codfil = this.filial.codfil
        } else{
            this.loadData()
        }
           this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/vcaixa-form.vue